// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2iAmx","unreadBadge":"styles_unreadBadge__3Fqj_","modalContent":"styles_modalContent__bBSQJ","modal":"styles_modal__20zXl"};